export default __webpack_public_path__ + "static/media/dilu.1d82b4e1.png";